module.exports = __webpack_public_path__ + "static/media/gmdm.cc46916f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/it/gmdm.png
// module id = 134
// module chunks = 0